<template>
<div class="pbulic_main white-bg mc-mt-40">
    <div class="main_content">
        <div class="mc-flex footer-service">
            <div class="item mc-flex mc-items-center mc-flex-justify-center">
                <span class="icon">正</span>
                <div class="text">
                    <div class="txt1 mc-size14 mc-bold">正品保证</div>
                    <div class="txt2 mc-size14">惠选优品 购物无忧</div>
                </div>
            </div>
            <div class="item mc-flex mc-items-center mc-flex-justify-center">
                <span class="icon">全</span>
                <div class="text">
                    <div class="txt1 mc-size14 mc-bold">全国配送</div>
                    <div class="txt2 mc-size14">专业服务 精准送达</div>
                </div>
            </div>
            <div class="item mc-flex mc-items-center mc-flex-justify-center">
                <span class="icon">增</span>
                <div class="text">
                    <div class="txt1 mc-size14 mc-bold">增票保障</div>
                    <div class="txt2 mc-size14">全场商品 保证增票开具</div>
                </div>
            </div>
            <div class="item mc-flex mc-items-center mc-flex-justify-center">
                <span class="icon">专</span>
                <div class="text">
                    <div class="txt1 mc-size14 mc-bold">专属价格</div>
                    <div class="txt2 mc-size14">企业采购 专享低价</div>
                </div>
            </div>
            <div class="item mc-flex mc-items-center mc-flex-justify-center">
                <span class="icon">上</span>
                <div class="text">
                    <div class="txt1 mc-size14 mc-bold">上市企业</div>
                    <div class="txt2 mc-size14">齐心集团 股票代码 002301</div>
                </div>
            </div>
        </div>

        <div class="mc-flex mc-flex-justify-between footer-nav">
            <div class="mc-text-center">
                <img src="@/assets/images/jt_logo.png" height="34px" />
                <!-- <div class="mc-mt-10">（{{company.hotline}}）</div> -->
                <div class="mc-mt-10">（0755-66829999）</div>
                <div class="mc-mt-5">工作日（9:00-18:00）</div>
                <!-- <div class="mc-mt-t">{{company.hotlineTime}}</div> -->
                <div class="mc-size16 mc-mt-10">在线客服</div>
                <!-- <div>{{company.email}}</div> -->
                <div>wei.li@qx.com</div>
            </div>
            <div class="mc-flex mc-flex-justify-between mc-size12 col-nav">
                <div class="col-links">
                    <div class="mc-size16 mc-mb-5">购物指南</div>
                    <div class="item-link"><a href="https://www.qx.com/Promo/Certificate" target="_blank">授权证书</a></div>
                    <div class="item-link"><a href="https://www.qx.com/article/details/3" target="_blank">购物流程</a></div>
                    <div class="item-link"><a href="https://www.qx.com/article/details/4" target="_blank">常见问题</a></div>
                </div>
                <div class="col-links">
                    <div class="mc-size16 mc-mb-5">配送方式</div>
                    <div class="item-link"><a href="https://www.qx.com/article/details/1" target="_blank">全国网络</a></div>
                    <div class="item-link"><a href="https://www.qx.com/article/details/7" target="_blank">签收事项</a></div>
                    <div class="item-link"><a href="https://www.qx.com/article/details/76" target="_blank">配送服务</a></div>
                </div>
                <div class="col-links">
                    <div class="mc-size16 mc-mb-5">支付方式</div>
                    <div class="item-link"><a href="https://www.qx.com/article/details/2" target="_blank">在线支付</a></div>
                    <div class="item-link"><a href="https://www.qx.com/article/details/9" target="_blank">公司转账</a></div>
                </div>
                <div class="col-links">
                    <div class="mc-size16 mc-mb-5">售后服务</div>
                    <div class="item-link"><a href="https://www.qx.com/article/details/79" target="_blank">退换货流程</a></div>
                </div>
                <div class="col-links">
                    <div class="mc-size16 mc-mb-5">商城入口</div>
                    <div class="item-link"><a href="https://www.comix.com.cn/" target="_blank">齐心商城</a></div>
                    <div class="item-link"><a href="https://fuli.qx.com?company_code=CO2023122810000" target="_blank">齐心福利商城</a></div>
                    <div class="item-link"><a href="https://b2b.comix.com.cn" target="_blank">齐心渠道宝</a></div>
                    <div class="item-link"><a href="https://comix.qx.com/" target="_blank">齐心国际</a></div>
                    <div class="item-link"><a href="https://qixinbgyp.tmall.com" target="_blank">齐心天猫官方旗舰店</a></div>
                    <div class="item-link"><a href="https://comix.jd.com" target="_blank">齐心京东自营官方旗舰店</a></div>
                </div>
                <div class="col-links">
                    <div class="mc-size16 mc-mb-5">关于我们</div>
                    <div class="item-link"><a href="https://about.qx.com/about/intro" target="_blank">齐心集团</a></div>
                    <div class="item-link"><a href="https://about.qx.com/contact/union" target="_blank">加入齐心</a></div>
                    <div class="item-link"><a href="https://www.qx.com/mobileShare/kpinfo/Areas/kpinfo/View/kpinfo.html?V1" target="_blank">开票资料</a></div>
                </div>
            </div>
            <div class="mc-text-center">
                <div class="mc-size16 mc-mb-5">齐心集团</div>
                <img src="@/assets/images/jt_qrcode.png" height="90px" />
            </div>
        </div>

        <div class="mc-ptb-20 mc-text-center mc-size12 footer-info">
            <div>
                <a href="https://about.qx.com/" target="_blank">关于齐心</a> <span class="info-line">|</span>
                <a href="https://www.qx.com/Home/Links" target="_blank">友情链接</a>
            </div>
            <div>
                <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="nofollow">粤ICP备05143967号</a> <span class="info-line">|</span> 增值电信业务经营许可证：<a href="https://oss.qx.com/cert/ISP%2BIDC证书01.jpg" target="_blank" rel="nofollow">B1-20203067</a>、<a href="https://oss.qx.com/cert/comix-icp.jpg" target="_blank" rel="nofollow">粤B2-20150312</a><span class="info-line">|</span> <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44031002000228" target="_blank" rel="nofollow">公安备案号：44031002000228</a> <span class="info-line">|</span> <a href="https://oss.qx.com/cert/certificates2.jpg" target="_blank" rel="nofollow"> 食品经营许可证编号：JY14403040260602</a>
            </div>
            <div>
                Copyright © 2022 深圳齐心集团股份有限公司(<a href="http://www.cninfo.com.cn/new/disclosure/stock?orgId=9900008467&amp;stockCode=002301" target="_blank">002301.SZ</a>) 版权所有 <span class="info-line">|</span> <a href="https://oss.qx.com/cert/certificates1.jpg" target="_blank" rel="nofollow">营业执照</a>
            </div>
        </div>

        <div class="mc-text-center footer-link">
            <a href="https://merchant.unionpay.com/" target="_blank" rel="nofollow">
                <img src="https://www.qx.com/Areas/Shop/Themes/Comix/Content/Themes/v4/images/common/footer-link1.png">
            </a>
            <a href="https://e.alipay.com/" target="_blank" rel="nofollow">
                <img src="https://www.qx.com/Areas/Shop/Themes/Comix/Content/Themes/v4/images/common/footer-link2.png">
            </a>
            <a href="https://pay.weixin.qq.com/" target="_blank" rel="nofollow">
                <img src="https://www.qx.com/Areas/Shop/Themes/Comix/Content/Themes/v4/images/common/footer-link3.png">
            </a>

            <a href="https://tsm.miit.gov.cn" target="_blank" rel="nofollow">
                <img src="https://www.qx.com/Areas/Shop/Themes/Comix/Content/Themes/v4/images/common/footer-link6.png">
            </a>
            <a href="https://www.12377.cn/" target="_blank" rel="nofollow">
                <img src="https://www.qx.com/Areas/Shop/Themes/Comix/Content/Themes/v4/images/common/footer-link7.png">
            </a>
            <a href="http://www.wenming.cn/" target="_blank" rel="nofollow">
                <img src="https://www.qx.com/Areas/Shop/Themes/Comix/Content/Themes/v4/images/common/footer-link8.png">
            </a>
            <a href="https://szcert.ebs.org.cn/ade28099-e557-40e9-b8f1-2c85409bb5d5" target="_blank" rel="nofollow">
                <img src="https://szcert.ebs.org.cn/Images/newGovIcon.gif" >
            </a>
            <a href="https://ss.knet.cn/verifyseal.dll?sn=e14112544030056384sfmy000000&amp;ct=df&amp;a=1&amp;pa=337337" target="_blank" rel="nofollow">
                <img src="https://www.qx.com/Areas/Shop/Themes/Comix/Content/Themes/v4/images/common/footer-link10.png">
            </a>
        </div>
    </div>
</div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  data() {
    return {
      navArr: [],
    };
  },
  mounted() {
    // this.getFooter();
  },
  computed: {
    ...mapState({
      company: 'company'
    })
  },
  methods: {
    async getFooter() {
      await this.$axios
        .post(this.$http.api + "/v1/community/mrohomefooterlist")
        .then((res) => {
          if (!res.code) {
            this.navArr = res.data;
          } else {
            this.navArr = [];
          }
        });
    },
  },
};
</script>
<style lang='less' scoped>
@import "~@/assets/css/less.less";
.footer-service {
    padding: 50px 0;
    .item {
        width: 239px;
        border-left: 1px solid #d2d2d2;
        &:first-child {
            border-left: none;
        }
    }
    .icon {
        width: 34px;
        height: 34px;
        line-height: 34px;
        border: 2px solid #e50011;
        border-radius: 2px;
        text-align: center;
        font-size: 24px;
        color: #e50011;
    }
    .text {
        line-height: 16px;
        margin-left: 6px;
        .txt1 {
            color: #000;
        }
        .txt2 {
            color: #757575;
            margin-top: 6px;
        }
    }
}
.footer-nav {
    padding: 30px 0 20px;
    border-top: 1px solid #e8e8e8;
    .col-nav {
        width: 760px;
        .item-link {
            line-height: 20px;
            a {
                color: @gray6;
                &:hover {
                    color: #E4393C;
                    text-decoration: underline;
                }
            }
        }
    }
}
.footer-info {
    line-height: 24px;
    border-top: 1px solid #e8e8e8;
    .info-line {
        margin: 0 4px;
        color: @ccc;
    }
    a {
        color: @gray3;
        &:hover {
            color: #E4393C;
            text-decoration: underline;
        }
    }
}
.footer-link {
    padding-bottom: 30px;
    a {
        display: inline-block;
        width: 108px;
        height: 44px;
        vertical-align: top;
        margin: 0 3px;
        img {
            width: 100%;
            height: 100%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue